import Auth from './auth';

class Clients {
  load(hostname) {
    const defaultConfig = {
      post_logout_redirect_uri: `${Auth.url.protocol}//${Auth.url.host}/home/`,
      redirect_uri: `${Auth.url.protocol}//${Auth.url.host}/home/`
    };

    let clients = new Map();

    if (process.env.NODE_ENV === 'local') {
      clients.set('default', {
        ...defaultConfig,
        client_id: '551341714070273570-3f4o7ssug4mu591q9ykxa4mmoi7yao13'
      });

      clients.set('takeuchi-us.localhost:89', {
        ...defaultConfig,
        client_id: '551341714070273570-sag8mckosq9ag6hocojeoqh13zwpqgnq',
        acr_values: 'tenant:429932458'
      });

      clients.set('genie.localhost:89', {
        ...defaultConfig,
        client_id: '551341714070273570-8jpkhteedzxr89fyckppkkgnumd6ob4g'
      });

      clients.set('trackpoint.localhost:89', {
        ...defaultConfig,
        client_id: '551341714070273570-m5wowrfxbqipru67r3syof154fdpdugw'
      });
    }

    if (process.env.NODE_ENV === 'staging') {
      clients.set('default', {
        ...defaultConfig,
        client_id: '551341714070273570-3f4o7ssug4mu591q9ykxa4mmoi7yao13'
      });

      clients.set('takeuchi-us-staging.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-6mi4osjbca6tnu4g1xe1imkb5cuwmrug',
        acr_values: 'tenant:429932458'
      });

      clients.set('liftconnect.staging.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-8jpkhteedzxr89fyckppkkgnumd6ob4g'
      });

      clients.set('trackpoint.staging.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-g6rojy9rgfb9mg1jc3qkiquit41h8aw9'
      });
    }

    if (process.env.NODE_ENV === 'production') {
      clients.set('default', {
        ...defaultConfig,
        client_id: '551341714070273570-3f4o7ssug4mu591q9ykxa4mmoi7yao13'
      });

      clients.set('takeuchi-us.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-r3mmmqpg9hsqw835877ui9xeaf588obx',
        acr_values: 'tenant:284689514'
      });

      clients.set('takeuchi-us-sandbox.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-qynxxnim4yattjyrhojqun6ftak139rh',
        acr_values: 'tenant:429932458'
      });

      clients.set('liftconnect.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-hbhd1h8xmou6htjqp7ssmekcfz93hjm1'
      });

      clients.set('trackpoint.onei3.com', {
        ...defaultConfig,
        client_id: '551341714070273570-zszth4819hb46qdco11dbzma4tkzjm5a'
      });
    }

    let client = clients.get(hostname);

    if (client !== undefined) {
      return client;
    }

    return clients.get('default');
  }
}

export default new Clients();
